import React, { useState, useEffect } from "react";
import { Grid, makeStyles, createStyles, Theme, Button, Box, withStyles, Chip } from "@material-ui/core";
import { EventType } from "pages/statuses/EventType";
import * as CommonConstants from "utilities/CommonConstants";
import { ConfigGetter } from "utilities/ConfigGetter";
import * as ConfigKey from "utilities/ConfigGetter";
import { DateUtil } from "utilities/DateUtil";
import { BookingApi } from "api/BookingApi";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            marginRight: theme.spacing(5),
            marginLeft: theme.spacing(5),
            marginBottom: theme.spacing(1),
            textAlign: `center`,
        },
        caution: {
            marginBottom: theme.spacing(1),
            padding: theme.spacing(1),
            border: `1px solid`,
            borderColor: `gray`,
            borderRadius: `5px`,
        },
        mobilePmBox: {
            marginTop: theme.spacing(3),
        },
    })
);

const BookingTimeButtion = withStyles({
    root: {
        marginTop: '5px',
        color: '#ffffff',
        '&:hover': {
            opacity: 0.8,
        },
    },
})(Button)

interface Props {
    // 予約情報
    booking: EventType;
    // イベント
    events: EventType[];
    // 次へ
    handleNext: VoidFunction;
    // ローディング状態のセッター
    setLoading: any;
}

/**
 * 予約時間登録コンポーネント
 * 予約時間を登録するコンポーネント
 * @param props
 */
export const SelectBookingTime: React.FC<Props> = (props) => {
    const { booking, events, setLoading, handleNext } = props;
    const classes = useStyles();
    const isPcSize = useMediaQuery(CommonConstants.RESPONSIVE_MIN_WIDTH);

    const [solventBookingableTime1, setSolventBookingableTime1] = useState<EventType[]>([]);
    const [solventBookingableTime2, setSolventBookingableTime2] = useState<EventType[]>([]);

    // エラーメッセージ
    const [errorMessage, setErrorMessage] = useState<string>(``);

    useEffect(() => {
        const execute = async () => {
            // ローディング開始
           setLoading(true);

            // 予約可能時間を設定
            // 予約時間
            const startTimeAm = ConfigGetter.getNum(ConfigKey.BOOKING_START_TIME_AM);
            const endTimeAm = ConfigGetter.getNum(ConfigKey.BOOKING_END_TIME_AM);
            const startTimePm = ConfigGetter.getNum(ConfigKey.BOOKING_START_TIME_PM);
            const endTimePm = ConfigGetter.getNum(ConfigKey.BOOKING_END_TIME_PM);

            setSolventBookingableTime1(
                // events
                events.filter((e) => {
                    return (
                        e.bookingTypeId === booking.bookingTypeId &&
                        e.start.getMonth() === booking.start.getMonth() &&
                        e.start.getDate() === booking.start.getDate() &&
                        e.start.getHours() >= startTimeAm &&
                        e.start.getHours() <= endTimeAm
                    );
                })
            );
            setSolventBookingableTime2(
                // events
                events.filter((e) => {
                    return (
                        e.bookingTypeId === booking.bookingTypeId &&
                        e.start.getMonth() === booking.start.getMonth() &&
                        e.start.getDate() === booking.start.getDate() &&
                        e.start.getHours() >= startTimePm &&
                        e.start.getHours() <= endTimePm
                    );
                })
            );

            // ローディング終了
           setLoading(false);
        };
        execute();
        // eslint-disable-next-line
    }, []);

    /**
     * 予約情報設定
     */
    const setBooking = async (id: string, start: Date, end: Date, bookingTypeId: number | undefined) => {
        // 予約枠が空いているかどうかチェック
        const result: any = await BookingApi.checkFree(start, end, bookingTypeId !== undefined ? bookingTypeId : 0);
        if (result?.status === 200 && !result.data?.success) {
            if (result.data?.errorMessage !== null) {
                setErrorMessage(result.data?.errorMessage);
            } else {
                setErrorMessage(result.errors?.errorMessage);
            }
            return;
        }
        booking.start = start;
        booking.end = end;
        
        handleNext()
    };
   
    return (
        <div className={classes.form}>
            <p className="error">{errorMessage}</p>
            {isPcSize ? (
                <>
                <Grid container spacing={3} direction="row" justify="center" alignItems="stretch">
                    <Grid item md={6}>
                        <Box>
                            <div className={classes.caution}>＜ 午前の部 / 当日予約締切：{ConfigGetter.get(ConfigKey.BOOKING_DEADLINE_AM)} ＞</div>
                        </Box>
                        {solventBookingableTime1.map((item) => {
                            return (
                                <Box key={item.id}>
                                    <BookingTimeButtion
                                        variant="outlined"
                                        style={{
                                            border: `solid 2px ${item.color}`,
                                            background: `${item.color}`,
                                        }}
                                        onClick={() => setBooking(item.id, item.start, item.end, item.bookingTypeId)}
                                    >
                                        {DateUtil.parseViewTime(item.start, item.end)}
                                    </BookingTimeButtion>
                                </Box>
                            );
                        })}
                    </Grid>
                    <Grid item md={6}>
                        <Box>
                            <div className={classes.caution}>＜ 午後の部 / 当日予約締切：{ConfigGetter.get(ConfigKey.BOOKING_DEADLINE_PM)} ＞</div>
                        </Box>
                        {solventBookingableTime2.map((item) => {
                            return (
                                <Box key={item.id}>
                                    <BookingTimeButtion
                                        variant="outlined"
                                        style={{
                                            border: `solid 2px ${item.color}`,
                                            background: `${item.color}`,
                                        }}
                                        onClick={() => setBooking(item.id, item.start, item.end, item.bookingTypeId)}
                                    >
                                        {DateUtil.parseViewTime(item.start, item.end)}
                                    </BookingTimeButtion>
                                </Box>
                            );
                        })}
                    </Grid>
                </Grid>
                </>
            ) : (
                <>
                <Grid container spacing={0} direction="row" justify="center" alignItems="stretch">
                    <Grid item xs={12} >
                        <Box>
                            <div className={`${classes.caution} small`}>＜ 午前の部 / 当日予約締切：{ConfigGetter.get(ConfigKey.BOOKING_DEADLINE_AM)} ＞</div>
                        </Box>
                        {solventBookingableTime1.map((item) => {
                            return (
                                <Box key={item.id} alignContent="flex-start">
                                    <BookingTimeButtion
                                        variant="outlined"
                                        style={{
                                            border: `solid 2px ${item.color}`,
                                            background: `${item.color}`,
                                        }}
                                        onClick={() => setBooking(item.id, item.start, item.end, item.bookingTypeId)}
                                    >
                                        {DateUtil.parseViewTime(item.start, item.end)}
                                    </BookingTimeButtion>
                                </Box>
                            );
                        })}
                    </Grid>
                    <Grid item xs={12} className={classes.mobilePmBox} >
                        <Box>
                            <div className={`${classes.caution} small`}>＜ 午後の部 / 当日予約締切：{ConfigGetter.get(ConfigKey.BOOKING_DEADLINE_PM)} ＞</div>
                        </Box>
                        {solventBookingableTime2.map((item) => {
                            return (
                                <Box key={item.id}>
                                    <BookingTimeButtion
                                        variant="outlined"
                                        style={{
                                            border: `solid 2px ${item.color}`,
                                            background: `${item.color}`,
                                        }}
                                        onClick={() => setBooking(item.id, item.start, item.end, item.bookingTypeId)}
                                    >
                                        {DateUtil.parseViewTime(item.start, item.end)}
                                    </BookingTimeButtion>
                                </Box>
                            );
                        })}
                    </Grid>
                </Grid>
                </>
            )}
        </div>
    );
};
